.controls {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: var(--padding-base-x);
}

.options {
	flex-direction: row;
	flex-wrap: wrap;
	gap: 0;
}

.option {
	padding: var(--padding-base-y) var(--padding-base-x);
	background: var(--input-bg);
	border: 1px solid var(--input-border);
	margin-left: -1px;
}

.option:first-child {
	margin-left: 0;
	border-radius: var(--input-border-radius) 0 0 var(--input-border-radius);
}

.option:last-child {
	border-radius: 0 var(--input-border-radius) var(--input-border-radius) 0;
}

.option:has([data-checked]) {
	color: var(--color-primary-outline);
	background: var(--alert-primary-bg);
}
